import type { FC, JSX } from 'react'
import type { IPopupComponentProps } from 'blocks/Popup'

import {
  WrapperBlock,
  WrapperDisplay,
  WrapperJustifyContent,
} from 'atoms/WrapperBlock'
import { PopupComponent } from 'blocks/Popup'
import { ShoppingCartPopupHeader } from 'blocks/TextBlock/Templates/Popup/ShoppingCartPopupHeader'
import { COLOR } from 'vars/color'
import { FIXED_INDENTS } from 'vars/fixed-indents'
import { ShoppingCartRedirectButtonSC } from './ShoppingCartRedirectPopup.styled'

export interface IShoppingCartRedirectPopup extends Omit<
  IPopupComponentProps,
  'children'
> {
  title: string
  description?: string
  buttonTitle: string
  onClick: () => void
  isOpened: boolean
  isLoading?: boolean
}

export const ShoppingCartRedirectPopup: FC<IShoppingCartRedirectPopup> = ({
  title = '',
  description = '',
  overlayColor = COLOR.SURFACE_OPACITY_DARK_70,
  buttonTitle = '',
  onClick,
  isOpened = false,
  isShoppingCartPopup = true,
  isLoading,
  ...rest
}): JSX.Element | null => {
  return isOpened ? (
    <PopupComponent
      overlayColor={overlayColor}
      isShoppingCartPopup={isShoppingCartPopup}
      {...rest}
    >
      <ShoppingCartPopupHeader title={title} description={description} />
      <WrapperBlock
        display={WrapperDisplay.FLEX}
        justifyContent={WrapperJustifyContent.CENTER}
        width='100%'
      >
        <ShoppingCartRedirectButtonSC
          title={buttonTitle}
          onClick={onClick}
          withLoader
          isLoading={isLoading}
          hideTitleOnLoading
          disabled={isLoading}
          paddings={[FIXED_INDENTS.INDENT_30, FIXED_INDENTS.INDENT_60]}
        />
      </WrapperBlock>
    </PopupComponent>
  ) : null
}
